import { CartSubscription, WishlistSubscription, } from '../../common/event-bus/EventSubscription';
export var getActionItems = function (_a) {
    var customer = _a.customer, cartCount = _a.cartCount, wishlistCount = _a.wishlistCount;
    return [
        {
            // INFO: We are using the same ids to trick React into
            // thinking that those items are the same
            id: 'userAccount',
            icon: 'Account',
            label: 'h24_register',
            url: 'h24_login_page_url',
            showTooltip: true,
            auth: false,
            customer: customer,
        },
        {
            id: 'userAccount',
            icon: 'Account',
            label: 'h24_my_account',
            url: 'h24_my_overview_url',
            showTooltip: true,
            auth: true,
            customer: customer,
        },
        {
            id: 'wishlist',
            icon: 'Wishlist',
            label: 'h24_wishlist',
            url: 'h24_wishlist_url',
            initialCount: wishlistCount,
            Subscription: WishlistSubscription,
        },
        {
            id: 'cart',
            icon: 'Cart',
            label: 'h24_cart',
            url: 'h24_cart_url',
            initialCount: cartCount,
            Subscription: CartSubscription,
            countThreshold: 0,
        },
    ];
};
export var PAYBACK_ACTION_ITEM = {
    id: 'payback',
    icon: 'Payback',
    label: 'h24_payback',
    url: 'h24_payback_page_url',
    desktopOnly: true,
};
